module.exports = __webpack_public_path__ + "static/media/50.ece2be65.jpg";